import { useEffect, useState } from 'react';
import config from '../services/publishingGroupConfig.json';

export default function usePublicAuthor(host) {
  const [author, setAuthor] = useState(null);
  useEffect(() => {
    let canceled = false;
    setAuthor(null);
    if (!host || !config.apiBase) return;
    fetch(`${config.apiBase}/public-author?host=${encodeURIComponent(host)}`, { signal: AbortSignal.timeout(15000) })
      .then(response => { if (!response.ok) throw new Error('Unable to load author'); return response.json(); })
      .then(data => { if (!canceled) setAuthor(data.author || { unavailable: true }); })
      .catch(() => { if (!canceled) setAuthor({ unavailable: true }); });
    return () => { canceled = true; };
  }, [host]);
  return author;
}
